import { fetchClientJSON } from '../../../services/clientDataService';
import { getClientType } from '../../../tools/session/clientSession';
import sample from '../data/laSpeziaSample.json';
import { enrichCatalogFixture } from '../data/v2Fixtures';

export async function loadSemafixCatalog() {
  try {
    return await fetchClientJSON(getClientType(), 'semafix/network.json');
  } catch (error) {
    console.info('SEMAFIX upload data is not available; using the bundled La Spezia sample.', error);
    return enrichCatalogFixture(sample);
  }
}
